import { FormattedMessage } from 'react-intl'

import { cn } from '@gto/ui/cn'
import { Link } from '@gto/ui/link'
import { Typography } from '@gto/ui/typography'

import { useSupportLinks } from '@/components/support-links'

export const PromoSupportSection = () => {
  const supportLinks = useSupportLinks()

  return (
    <section className="flex flex-col gap-10">
      <Typography
        className="text-center"
        variant="body1"
      >
        <FormattedMessage id="promo.support.title" />
      </Typography>

      <div className="flex w-full flex-wrap gap-4">
        {supportLinks.map((link, index) => {
          const isHttp = link.href.startsWith('http')

          return (
            <Link
              // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed support-link list, never reorders
              key={index}
              aria-label={link['aria-label'] || link.label}
              external={isHttp}
              href={link.href}
              underline="onHover"
              className={cn(
                'inline-flex min-h-0 flex-[1_0_auto] flex-col rounded-md border border-divider bg-paper-elevation1 px-10 py-5',
                'text-text-primary transition-[color,border-color] duration-300',
                'hover:border-primary-main hover:text-primary-main',
                '[&_svg]:transition-colors hover:[&_svg]:text-primary-main',
              )}
            >
              <div className="flex flex-col items-center justify-center gap-2">
                {link.icon} <Typography color="inherit">{link.label}</Typography>
              </div>
            </Link>
          )
        })}
      </div>
    </section>
  )
}
